import api from '@/api';

export default {
  async generateToken(complementId: number) {
    const result = (await api.post(
      `/workorder/v1/Zf/partner/sso/generate-token?complementId=${complementId}`,
      {},
    )) as unknown;
    return result as string;
  },
};
